import { z } from "zod";

const createBookableTemplateZodObject = z.object({
    _id: z.string(),
    type: z.enum(["BOOKABLE"]),
    title: z.string(),
    subtitle: z.string(),
    description: z.string(),
    kicker: z.string(),
    targetDescription: z.string().optional(),
    infoBlocks: z.array(
        z.object({
            title: z.string(),
            description: z.string(),
        }),
    ),

    bookableQuantities: z.array(
        z.object({
            title: z.string(),
            subtitle: z.string(),
            quantity: z.number(),

            unit: z.object({
                singular: z.string(),
                plural: z.string(),
            }),

            prices: z.array(
                z.object({
                    title: z.string(),
                    priceInOre: z.number(),
                    vat: z.number(),
                    step: z.number(),
                    priceTimeGranularity: z.enum([
                        "FIXED",
                        "HOUR",
                        "DAY",
                        "NIGHT",
                        "MINUTE",
                    ]),

                    minQuantity: z.number(),
                    maxQuantity: z.number(),
                    defaultQuantity: z.number(),
                }),
            ),
        }),
    ),
});

// Create Buyable Template Schema
const createBuyableTemplateZodObject = z.object({
    _id: z.string(),
    type: z.enum(["BUYABLE"]),
    title: z.string(),
    subtitle: z.string(),
    description: z.string(),
    kicker: z.string(),
    targetDescription: z.string().optional(),
    miniDescription: z.string().optional(),

    price: z.object({
        priceInOre: z.number(),
        vat: z.number(),
    }),

    infoBlocks: z.array(
        z.object({
            title: z.string(),
            description: z.string(),
        }),
    ),
});

// Create Voucher Template Schema
const createVoucherTemplateZodObject = z.object({
    _id: z.string(),

    type: z.enum(["VOUCHER"]),
    title: z.string(),
    subtitle: z.string(),
    description: z.string(),
    kicker: z.string(),
    targetDescription: z.string().optional(),
    miniDescription: z.string().optional(),

    price: z.object({
        priceInOre: z.number(),
        vat: z.number(),
    }),

    contentBlocks: z.array(
        z.object({
            title: z.string(),
            content: z.string(),
        }),
    ),
});

const _createTemplateUnion = z.union([
    createBookableTemplateZodObject,
    createBuyableTemplateZodObject,
    createVoucherTemplateZodObject,
]);

type CreateTemplate = z.infer<typeof _createTemplateUnion>;

const createTemplatesZodObject = z.object({
    message: z.string(),
    bookables: z.array(createBookableTemplateZodObject),
    buyables: z.array(createBuyableTemplateZodObject),
    vouchers: z.array(createVoucherTemplateZodObject),
});

type CreateTemplates = z.infer<typeof createTemplatesZodObject>;
export { createBookableTemplateZodObject, createTemplatesZodObject };
export type { CreateTemplate, CreateTemplates };
